import { CSSProperties, useState } from 'react';

import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Popover } from '~/commonComponents/Popover/Popover';
import { IBadge } from '~/domain/RecommendedProfessionals/recommendedProfessionalsTypes';

import ConfirmPopup from '~/components/shared/ConfirmPopup';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
/** keeps the popover label on one line; whiteSpace has no DS Typography prop */
const labelNowrapStyle: CSSProperties = { whiteSpace: 'nowrap' };

interface IAttendanceBadgeInlineProps {
  badges: IBadge[];
}

const ATTENDANCE_BADGE_TYPE = 'attendance-score';
const BADGE_SIZE = 26;

const AttendanceBadgeInline = ({ badges }: IAttendanceBadgeInlineProps) => {
  const [showPopup, setShowPopup] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const badge = badges.find((b) => b.type === ATTENDANCE_BADGE_TYPE);

  if (!badge) {
    return null;
  }

  const Target = () => (
    <button
      type="button"
      style={{
        all: 'unset',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => setShowPopup(true)}
      aria-label={badge.label}
    >
      <img
        src={badge.imageUrl}
        alt={badge.label}
        width={BADGE_SIZE}
        height={BADGE_SIZE}
        style={{
          boxShadow: isHovered ? '0px 2px 6px rgba(0, 0, 0, 0.25)' : 'none',
          borderRadius: '50%',
          transition: 'box-shadow 0.2s',
        }}
      />
    </button>
  );

  const Content = () => (
    <Typography color={colors.neutral['600']} textAlign="center" style={labelNowrapStyle}>
      {badge.label}
    </Typography>
  );

  return (
    <>
      <Popover Target={Target} Content={Content} trigger="hover" position="bottom" offset={16} />

      {showPopup && (
        <ConfirmPopup
          rightButtonAction={() => setShowPopup(false)}
          rightButtonText="Got it!"
          title={
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginTop: 18,
              }}
            >
              <span className="global_font f-dark f-18" style={{ marginRight: 5 }}>
                {badge.popupTitle}
              </span>
              {badge.popupTitleIcon && (
                <img src={badge.popupTitleIcon} alt="icon" style={{ width: 22, height: 22 }} />
              )}
            </div>
          }
          titleStyle={{ marginBottom: 5 }}
          description={badge.popupDescription}
          Icon={() =>
            badge.popupImageWeb ? (
              <img src={badge.popupImageWeb} alt="popup" style={{ width: '50%' }} />
            ) : null
          }
        />
      )}
    </>
  );
};

export default AttendanceBadgeInline;
